<div class="oase-kontakt">
	<mat-card appearance="outlined">
		<mat-card-title>
			{{ OBJ_LNG_NAME+'.liste' | translate:locale.language }} <span *ngIf="dataSource" class="anzahl"> ({{ 'allgemein.daten.insgesamt' | translate:locale.language:{ count: dataSource.page.totalElements } }})</span>
			<p class="errors" *ngIf="dataService.fehler" [innerHTML]="dataService.fehler.messagehtml"></p>
			<p class="errors" *ngIf="fehlerMain" [innerHTML]="fehlerMain.messagehtml"></p>
		</mat-card-title>
		<mat-card-content>

			<div class="tabelle">
				<div class="tabelle-kopf" [style.display]="">
					<mat-form-field>
						<input matInput #filter>
						<mat-label>
							<i class="material-icons app-input-icon">search</i> {{ 'allgemein.suche' | translate:locale.language }}
						</mat-label>
						<button matSuffix mat-icon-button class="suche" (click)="clearFilter()" matTooltip="{{ 'allgemein.klick.leeresuche' | translate:locale.language }}"
								[disabled]="dataSource.isWaitingForResponse || filter.value == ''"><mat-icon>close</mat-icon></button>
					</mat-form-field>
				</div>

				<!-- Wenn eine Auswahl nicht benötigt wird einfach in displayedColumns die Spalte select nicht einbinden -->

				<div class="ladedaten" *ngIf="dataSource.isWaitingForResponse">
					<div>{{ 'allgemein.daten.laden.start' | translate:locale.language }} <mat-icon>free_breakfast</mat-icon></div>
					<div><mat-spinner color="primary"></mat-spinner></div>
					<div>{{ 'allgemein.daten.laden.ende' | translate:locale.language }}</div>
				</div>

				<mat-table #table [dataSource]="dataSource" matSort>

					<ng-container matColumnDef="vorname">
						<mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10">{{ OBJ_LNG_NAME+'.vorname' | translate:locale.language }}</mat-header-cell>
						<mat-cell class="with-image" fxFlex="10" *matCellDef="let row">

							{{ row.vorname }}&nbsp;

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="nachname">
						<mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10">{{ OBJ_LNG_NAME+'.nachname' | translate:locale.language }}</mat-header-cell>
						<mat-cell class="with-image" fxFlex="10" *matCellDef="let row">

							{{ row.nachname }}&nbsp;

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="funktion">
						<mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="20">{{ OBJ_LNG_NAME+'.funktion' | translate:locale.language }}</mat-header-cell>
						<mat-cell class="with-image" fxFlex="20" *matCellDef="let row">

							{{ row.funktion }}&nbsp;

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="email">
						<mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="20">{{ OBJ_LNG_NAME+'.email' | translate:locale.language }}</mat-header-cell>
						<mat-cell class="with-image" fxFlex="20" *matCellDef="let row">

							{{ row.email }}

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="telefon">
						<mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="8">{{ OBJ_LNG_NAME+'.telefon' | translate:locale.language }}</mat-header-cell>
						<mat-cell class="with-image" fxFlex="8" *matCellDef="let row">

							{{ row.telefon }}&nbsp;

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="fax">
						<mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="4">{{ OBJ_LNG_NAME+'.fax' | translate:locale.language }}</mat-header-cell>
						<mat-cell class="with-image" fxFlex="4" *matCellDef="let row">

							{{ row.fax }}&nbsp;

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="hofberater">
						<mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="8">{{ OBJ_LNG_NAME+'.hofberater' | translate:locale.language }}</mat-header-cell>
						<mat-cell class="with-image" fxFlex="8" *matCellDef="let row">

							{{ row.hofberater }}&nbsp;

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="kategorieBezeichnung">
						<mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10">{{ OBJ_LNG_NAME+'.kontaktart' | translate:locale.language }}</mat-header-cell>
						<mat-cell class="with-image" fxFlex="10" *matCellDef="let row">

							{{ row.kategorieBezeichnung }}&nbsp;

						</mat-cell>
					</ng-container>

					<!-- admin Column -->

					<ng-container matColumnDef="admin">
						<mat-header-cell *matHeaderCellDef fxFlex="10">{{ OBJ_LNG_NAME+'.admin' | translate:locale.language }}</mat-header-cell>
						<mat-cell *matCellDef="let row" fxFlex="10">

						<button mat-icon-button (click)="zeigeBearbeitenMaske(row)" matTooltip="{{ 'allgemein.klick.bearbeiten' | translate:locale.language:{ bestimmt: OBJ_LNG_NAME+'.artikel.bestimmt' | translate:locale.language, typ: OBJ_LNG_NAME+'.typ' | translate:locale.language } }}"><mat-icon>edit</mat-icon></button>
						<button mat-icon-button (click)="zeigeLoeschenMaske(row)" matTooltip="{{ 'allgemein.klick.löschen' | translate:locale.language:{ bestimmt: OBJ_LNG_NAME+'.artikel.bestimmt' | translate:locale.language, typ: OBJ_LNG_NAME+'.typ' | translate:locale.language } }}"><mat-icon>delete</mat-icon></button>

						</mat-cell>
					</ng-container>

					<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: displayedColumns; let i = index;" ></mat-row>

				</mat-table>

				<div class="sucheleer" [style.display]="dataSource.page.totalElements > 0 && dataSource.page.searchElements == 0 ? '' : 'none'">
					{{ 'allgemein.daten.sucheleer' | translate:locale.language }}
				</div>

				<div class="keinedaten" [style.display]="dataSource.page.totalElements == 0 ? '' : 'none'">
					{{ 'allgemein.daten.keine' | translate:locale.language }}
				</div>

				<mat-paginator #paginator
							   [length]="dataSource.page.searchElements"
							   [pageIndex]="0"
							   [pageSize]="10"
							   [pageSizeOptions]="[5,10,15,20,25,30,50,100,200,500]">
				</mat-paginator>
			</div>
		</mat-card-content>
	</mat-card>

</div>

<!-- add button -->

<div class="globalbuttons">
	<button *ngIf="!dataSource.isWaitingForResponse" mat-fab class="pull-right" type="button" matTooltip="{{ 'allgemein.klick.hinzufügen' | translate:locale.language:{ unbestimmt: OBJ_LNG_NAME+'.artikel.unbestimmt' | translate:locale.language, typ: OBJ_LNG_NAME+'.typ' | translate:locale.language } }}" matTooltipPosition="above"
			(click)="zeigeHinzufuegenMaske()"><mat-icon>add</mat-icon></button>
</div>

